module.exports = __webpack_public_path__ + "img/factor_a_red.b8e9caf9.svg";